import { render, staticRenderFns } from "./UD.operation.vue?vue&type=template&id=71432379&"
import script from "./UD.operation.vue?vue&type=script&lang=js&"
export * from "./UD.operation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71432379')) {
      api.createRecord('71432379', component.options)
    } else {
      api.reload('71432379', component.options)
    }
    module.hot.accept("./UD.operation.vue?vue&type=template&id=71432379&", function () {
      api.rerender('71432379', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Crud/UD.operation.vue"
export default component.exports